import { Goal } from '@griply/types';

export const filterOutArchivedGoals = (goals: Goal[]): Goal[] =>
  goals.filter(({ archivedAt }) => !archivedAt);
